<template>
  <div class="ccui-app-container">
    <div class="top">
      <el-search
        :formProp="formData"
        @resetForm="resetForm"
        :selectClear="true"
        :spoNum="3"
        width="400px"
        @search="search"
      >
        <div class="ccui-advanced-search-wrapper ccui-clearfix my-tab">
          <el-button class="tab" :type="'table-top-active'" size="mini"
            >全部({{ totalNum }})
          </el-button>
        </div>
        <template slot="search">
          <el-input
            v-model.trim="formData.seekTitle"
            clearable
            placeholder="请输入标题模糊查询"
            searchLabel="标题"
          ></el-input>
          <el-select
            v-model="formData.sourceSystem"
            clearable
            searchLabel="业务来源"
            placeholder="请选择业务来源"
          >
            <el-option
              v-for="item in optionsLists.sourceSystem"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.purchaseMethod"
            clearable
            searchLabel="采购方式"
            placeholder="请选择采购方式"
          >
            <el-option
              v-for="item in optionsLists.purchaseMethod"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.releaseTimeType"
            clearable
            searchLabel="发布时间"
            placeholder="请选择发布时间"
          >
            <el-option
              v-for="item in optionsLists.releaseTimeType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.caterycodes"
            clearable
            multiple
            searchLabel="物资分类"
            placeholder="请选择物资分类"
          >
            <el-option
              v-for="item in optionsLists.caterycodes"
              :key="item.classifyCode"
              :label="item.classifyName"
              :value="item.classifyCode"
            ></el-option>
          </el-select>
        </template>
        <el-input
          slot="searchItem1"
          v-model.trim="formData.seekTitle"
          clearable
          placeholder="请输入标题模糊查询"
          searchLabel="标题"
        ></el-input>
        <el-select
          slot="searchItem2"
          v-model="formData.sourceSystem"
          clearable
          searchLabel="业务来源"
          placeholder="请选择业务来源"
        >
          <el-option
            v-for="item in optionsLists.sourceSystem"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          slot="searchItem3"
          v-model="formData.purchaseMethod"
          clearable
          searchLabel="采购方式"
          placeholder="请选择采购方式"
        >
          <el-option
            v-for="item in optionsLists.purchaseMethod"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          slot="searchItem4"
          v-model="formData.releaseTimeType"
          clearable
          searchLabel="发布时间"
          placeholder="请选择发布时间"
        >
          <el-option
            v-for="item in optionsLists.releaseTimeType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          slot="searchItem5"
          v-model="formData.caterycodes"
          clearable
          multiple
          searchLabel="物资分类"
          placeholder="请选择物资分类"
        >
          <el-option
            v-for="item in optionsLists.caterycodes"
            :key="item.classifyCode"
            :label="item.classifyName"
            :value="item.classifyCode"
          ></el-option>
        </el-select>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-if="tableHack"
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        @cell-click="cellClick"
        :cell-style="cellStyle"
        border
        class="ccui-multifunctional-table"
        @header-dragend="tableTitleWidth"
        @selection-change="handleSelectionChange"
        :min-height="9999"
        :max-height="99999"
      >
        <el-table-column fixed="left" label="序号" type="index" width="50" />
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :type="table.type"
            :key="index"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :align="table.align"
            :header-align="table.headerAlign || 'left'"
            :formatter="table.formatter"
            :show-overflow-tooltip="true"
          >
            <template #default="{ row }">
              <span
                v-html="formatCellContent(row, table.prop, table.type)"
              ></span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" :width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              v-for="e in filteredOptions(row)"
              :disabled="row.isRegistration == 1 ? true : false"
              :key="e.value"
              type="text"
              @click="handleClick(row, e.value)"
            >
              {{ e.label }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-if="totalNum > 0">
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="formDataSearch.pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSessionItem } from "@/config/utils";
import {
  querySeekSupplierPage,
  seekClassify
} from "@/app/announcement/api/all";
import { supplierRegister } from "@/app/electronicQuotation/api/all";

export default {
  data() {
    return {
      tableHack: true,
      loading: false,
      tableData: [],
      unfixedTableThead: [
        {
          label: "公告名称",
          prop: "seekTitle",
          width: "230",
          checked: true,
          align: "left"
        },
        {
          label: "供应商名称",
          prop: "supplierName",
          width: "180",
          checked: true,
          align: "left"
        },
        {
          label: "产品类别",
          prop: "cateryname",
          width: "88",
          checked: true,
          align: "left"
        },
        {
          label: "采购方式",
          prop: "purchaseMethod",
          width: "80",
          checked: true,
          align: "left",
          type: "purchaseMethod"
          // formatter: function(row, column, cellValue) {
          //   switch (cellValue) {
          //     case 1:
          //       return "邀请询价";
          //   }
          // }
        },
        {
          label: "业务来源",
          prop: "sourceSystem",
          width: "80",
          checked: true,
          align: "left",
          type: "sourceSystem"
          // formatter: function(row, column, cellValue) {
          //   switch (cellValue) {
          //     case 1:
          //       return "厂商资源";
          //   }
          // }
        },
        {
          label: "发布时间",
          prop: "seekStartTime",
          width: "144",
          checked: true,
          align: "left"
        },
        {
          label: "截止时间",
          prop: "seekOffTime",
          width: "144",
          checked: true,
          align: "left"
        }
      ],
      fixedTableThead: [],
      // 表格数据
      tableThead: [],
      tableTheadOptions: [],
      options: [
        {
          value: 1,
          label: "报价"
        }
      ],
      tableSelectLists: [],
      totalNum: 0,
      formData: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: false
      },
      formDataSearch: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: true
      },
      searchForm: {},
      optionsLists: {
        sourceSystem: [
          { label: "二级集采", value: 1 },
          { label: "租赁", value: 2 },
          { label: "mro电商", value: 0 }
        ],
        // 新增的东西
        purchaseMethod: [
          { label: "邀请询价", value: 1 },
          { label: "公开询价", value: 7 }
        ],
        releaseTimeType: [
          { label: "近3天", value: "THREE_DAYS" },
          { label: "近一周", value: "ONE_WEEK" },
          { label: "近一个月", value: "ONE_MONTH" }
        ],
        caterycodes: []
      }
    };
  },
  activated() {
    this.tableTheadOptions = this.fixedTableThead.concat(
      this.unfixedTableThead
    );
    this.init();
    this.getSeekClassify();
  },
  methods: {
    formatCellContent(row, prop, type) {
      const cellValue = row[prop];
      const PROCUREMENT_METHOD_MAP = {
        1: "邀请询价",
        7: "公开询价"
      };

      switch (type) {
        case "time":
          return cellValue ? cellValue.substring(0, 10) : "-";

        case "sourceSystem":
          return cellValue === 1 ? "二级集采" : cellValue === 2 ? "租赁" : "-";

        case "purchaseMethod":
          if (row?.sourceSystem == 1) {
            return PROCUREMENT_METHOD_MAP[row.purchaseMethod] || "-";
          }
          return cellValue === 1 ? "邀请询价" : "-";

        case "num":
          return cellValue.toFixed(2);

        default:
          return cellValue || "-";
      }
    },
    init() {
      querySeekSupplierPage({
        ...this.searchForm,
        ...this.formDataSearch
      }).then(res => {
        if (res.data.code == "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
        }
      });
    },
    getSeekClassify() {
      seekClassify().then(res => {
        if (res.data.code == "0") {
          this.optionsLists.caterycodes = res.data.data;
        }
      });
    },
    search(val) {
      this.formDataSearch.pageNo = 1;
      this.searchForm = val;
      this.init();
    },
    cellClick(row, column) {
      if (["skuId"].includes(column.property)) {
        // this.goDetail(row)
      }
    },
    cellStyle({ column }) {
      if (["skuId"].includes(column.property)) {
        // return { color: '#0089EF', cursor: 'pointer' }
      }
    },
    tableTitleWidth(newWidth, oldWidth, column) {
      console.log(12313123123);
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);

      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);

      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.tableHack = false;
      this.$nextTick(() => {
        this.tableHack = true;
      });
    },
    filteredOptions(row) {
      const optionsMap = {
        0: [this.options[0]],
        1: [this.options[0]]
      };

      return optionsMap[row.isRegistration] || [];
    },
    handleClick(row) {
      supplierRegister({
        seekId: row.seekId,
        supplierId: row.supplierId,
        supplierCode: row.supplierCode,
        supplierName: row.supplierName,
        contactsName: row.contactsName,
        contactsPhone: row.contactsPhone
      }).then(res => {
        if (res.data.code == "0") {
          this.$router.push(
            `/electronicQuotation/electronicQuotationDetail/detail/${row.seekId}/${res.data.data}`
          );
        }
      });
    },
    resetForm() {
      this.formData = {};
      this.formData.pageNo = 1;
    },
    handleSelectionChange(rows) {
      this.tableSelectLists = rows;
    },
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.inventoryInbound) || 10;
    },
    handlePrev() {},
    // 下一页
    handleNext() {},
    handleSizeChange(val) {
      this.formDataSearch.pageNo = 1;
      this.formDataSearch.pageSize = val;
      // setSessionItem("pageSize", this.tableName, val);
      this.init();
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.formDataSearch.pageNo = val;
      this.init();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-search .el-searchs {
  margin-top: -30px;
}

/deep/ .el-search {
  overflow: inherit !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
